export const enquiriesData = [
  {
    key: "1",
    CAR_IMG: "car-01.jpg",
    CAR: "Ford Endeavour",
    CAR_TYPE: "Sedan",
    CUSTOMER: "Reuben Keen",
    EMAIL: "reubenkeen@example.com",
    PHONE: "+1 56598 98956",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
  {
    key: "2",
    CAR_IMG: "car-02.jpg",
    CAR: "Ferrari 458 MM",
    CAR_TYPE: "Convertible",
    CUSTOMER: "William Jones",
    EMAIL: "williamjones@example.com",
    PHONE: "+1 24558 56599",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Replied",
  },
  {
    key: "3",
    CAR_IMG: "car-03.jpg",
    CAR: "Ford Mustang",
    CAR_TYPE: "Coupe",
    CUSTOMER: "Leonard Jandreau",
    EMAIL: "leonardjandreau@example.com",
    PHONE: "+1 25669 88985",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
  {
    key: "4",
    CAR_IMG: "car-04.jpg",
    CAR: "Toyota Tacoma 4",
    CAR_TYPE: "Hatchback",
    CUSTOMER: "Adam Bolden",
    EMAIL: "adambolden@example.com",
    PHONE: "+1 54698 55468",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
  {
    key: "5",
    CAR_IMG: "car-05.jpg",
    CAR: "Chevrolet Truck",
    CAR_TYPE: "Sedan",
    CUSTOMER: "Harvey Jimenez",
    EMAIL: "harveyjimenez@example.com",
    PHONE: "+1 32569 15458",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Not Opended",
  },
  {
    key: "6",
    CAR_IMG: "car-06.jpg",
    CAR: "Etios Carmen",
    CAR_TYPE: "Hatchback",
    CUSTOMER: "William Ward",
    EMAIL: "williamward@example.com",
    PHONE: "+1 65895 47878",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
  {
    key: "7",
    CAR_IMG: "car-07.jpg",
    CAR: "Acura Sport",
    CAR_TYPE: "Crossover",
    CUSTOMER: "Norman Coleman",
    EMAIL: "normancoleman@example.com",
    PHONE: "+1 14782 14578",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
  {
    key: "8",
    CAR_IMG: "car-08.jpg",
    CAR: "Kia Soul 2016",
    CAR_TYPE: "Delivery",
    CUSTOMER: "Jay Beckman",
    EMAIL: "jaybeckman@example.com",
    PHONE: "+1 12488 14457",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Not Opended",
  },
  {
    key: "9",
    CAR_IMG: "car-09.jpg",
    CAR: "Camaro",
    CAR_TYPE: "Station Wagon",
    CUSTOMER: "Francis Harris",
    EMAIL: "francisharris@example.com",
    PHONE: "+1 12781 02567",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Not Opended",
  },
  {
    key: "10",
    CAR_IMG: "car-10.jpg",
    CAR: "Toyota Camry",
    CAR_TYPE: "Mini Van",
    CUSTOMER: "Renaldo Labarre",
    EMAIL: "renaldolabarre@example.com",
    PHONE: "+1 12124 1425556",
    DATE: "25 May 2025",
    ENQUIRY: "",
    STATUS: "Opened",
  },
];
